/*
 *  This file global.action.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */


import { createAction, props } from '@ngrx/store';
import { TGlobalState } from './global.reducer';
import { FeedPayloadState, IFeedResponseExtended, IWidgetSequnceResponse, TFeedCountResponse, TGeneralEngageSettingResponse, TReferralDataResponse, TWallOfFameResponseItem } from 'src/app/modules/enterprise-wall/social-enterpise-wall/social-wall.model';
import { TContestEnableDisableResponse, TCoreFeatureValidate, TPageAccessRightStoreData, TWorkforceSetupSettingResponse, EGlobalStateStoreNames, TDepartment, TSubDepartment, TBusinessUnits, TLevel, TDesignation, TGrades, TRegion, TSubBranches, TTaxRegimeResponse, IMoodSettingType, TWorkflowInboxSetting, THelpdeskTicketFeedback } from './global.constants';
import { TSubscribeModuleResponse } from 'src/app/modules/team/team-dashboards/team-dashboards.model';
import { CompanyDataModel, CountryModel, StateModel, CityModel } from 'src/app/modules/onboarding-config/state-management/onboarding.models';
import { TGeneralSettingAPIResponse, TRecruiterAccessSettingAPIResponse } from 'src/app/global/models/recruitment-module-independent.model';
import { LocationType } from 'src/app/modules/processes/engage/events-management/events-management.model';
import { FeatureModel } from 'src/app/modules/core/integaration/one-ai/one-ai.model';
import { TExtensionSetting } from 'src/app/modules/core/time-office/time-office-setting/time-office-setting/time-office-setting.model';
import { IMoodReason } from 'src/app/modules/core/engage/moodbot-setting/moodbot.service';
import { PayrollGeneralSettingModel } from 'src/app/global/models/common.models';


export const refreshPageAccessRightStart = createAction(
  '[LogOnUser] Refresh Page Access Right Start',

);
export const emptyaction = createAction(
  '[Global State] EMPTY action',

);

export const refreshPageAccessRightSuccess = createAction(
  '[LogOnUser] Refresh Page Access Right Success',
  props<{ data: TPageAccessRightStoreData, storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const refreshPageAccessRightFailure = createAction(
  '[LogOnUser] Refresh Page Access Right Failure',

);



export const contestEnableDisableStart = createAction(
  '[Contest] Enterprise Contest Enable Disable Start',
  props<{ isHtmlData: boolean }>()
);

export const enterpriseEnableDisableSuccess = createAction(
  '[Contest] Enterprise Contest Enable Disable Success',
  props<{ data: TContestEnableDisableResponse[], storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const contestEnableDisableFailure = createAction(
  '[Contest] Enterprise Contest Enable Disable Failure',

);
export const employeecontestEnableDisableStart = createAction(
  '[Contest] Contest Employee Enable Disable Start',
  props<{ isHtmlData: boolean }>()
);

export const employeecontestEnableDisableSuccess = createAction(
  '[Contest] Contest Employee Enable Disable Success',
  props<{ data: { disabled: boolean }, storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const employeecontestEnableDisableFailure = createAction(
  '[Contest] Contest Employee Enable Disable Failure',

);


export const loadBadgeFeedStart = createAction(
  '[Engage] Load Badge Feed Start',
  props<{ payload: FeedPayloadState }>(),
);

export const loadBadgeFeedSuccess = createAction(
  '[Engage] Load Badge Feed Success',
  props<{ data: IFeedResponseExtended[], storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const loadFeedCountSuccess = createAction(
  '[Engage] Load Feed Count Success',
  props<{ data: TFeedCountResponse | null, storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const loadBadgeFeedFailure = createAction(
  '[Engage] Load Badge Feed Failure',

);


export const subscribeModuleStart = createAction(
  '[SubscribeModule] Subscribe Module Start',

);

export const subscribeModuleSuccess = createAction(
  '[SubscribeModule] Subscribe Module Success',
  props<{ data: TSubscribeModuleResponse | null, storename: string, versionId: string, employeeId: number, domainCode: string }>()
);
export const validateFeatureSuccess = createAction(
  '[Validate] Feature Success',
  props<{ data: Map<number, TCoreFeatureValidate>, storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const subscribeModuleFailure = createAction(
  '[SubscribeModule] Subscribe Module Failure',

);


export const workforceSettingStart = createAction(
  '[Workforce Setup] workforce Setting Start',
  props<{ settingId: string; activeStatus: number }>()
);

export const workforceSettingSuccess = createAction(
  '[Workforce Setup] workforce Setting Success',
  props<{
    data: Map<number, TWorkforceSetupSettingResponse>
    , storename: string, versionId: string, employeeId: number, domainCode: string
  }>()
);
export const workforceSettingFailure = createAction(
  '[Workforce Setup] workforce Setting Failed',

);
export const loadGlboalStateFromStorage = createAction(
  '[Global State] load state from storage',

);
export const updateGlboalStateFromStorage = createAction(
  '[Global State] update state from storage', props<{ state: any }>()

);
export const setGlboalStateToStorage = createAction(
  '[Global State] set state to storage', props<{ state: TGlobalState }>()

);
export const showRefreshFeed = createAction(
  '[Global State] Show Refresh Feed', props<{ show: boolean }>()
);

export const loadRankDetailSuccess = createAction(
  '[Engage] Load Rank Detail Success',
  props<{ data: TWallOfFameResponseItem[], storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const loadEnterpriseSuccess = createAction(
  '[Global] Load Enterprise Success',
  props<{
    data: any;
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadLegoOrgIdSuccess = createAction(
  '[Global] Load Lego Org Id Success',
  props<{
    data: string;
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadDepartmentsSuccess = createAction(
  '[Global] Load Departments Success',
  props<{
    data: TDepartment[];
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadSubDepartmentsSuccess = createAction(
  '[Global] Load SubDepartments Success',
  props<{
    data: TSubDepartment[];
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadBusinessUnitsSuccess = createAction(
  '[Global] Load Business Units Success',
  props<{
    data: TBusinessUnits[];
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadLevelsSuccess = createAction(
  '[Global] Load Levels Success',
  props<{
    data: TLevel[];
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadDesignationsSuccess = createAction(
  '[Global] Load Designations Success',
  props<{
    data: TDesignation[];
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadGradesSuccess = createAction(
  '[Global] Load Grades Success',
  props<{
    data: TGrades[];
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadSubBranchesSuccess = createAction(
  '[Global] Load SubBranches Success',
  props<{
    data: TSubBranches[];
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadBranchesSuccess = createAction(
  '[Global] Load Branches Success',
  props<{
    data: LocationType[];
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadRegionsSuccess = createAction(
  '[Global State] Load Regions Success',
  props<{
    data: TRegion[];
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadCompaniesSuccess = createAction(
  '[Global] Load Companies Success',
  props<{
    data: CompanyDataModel[];
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadCountriesSuccess = createAction(
  '[Global] Load Countries Success',
  props<{
    data: CountryModel[];
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadGeneralSettingsSuccess = createAction(
  '[Global] Load General Settings Success',
  props<{
    data: TGeneralEngageSettingResponse;
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadStatesSuccess = createAction(
  '[Global] Load States Success',
  props<{
    data: StateModel[];
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadCitiesSuccess = createAction(
  '[Global] Load Cities Success',
  props<{
    data: CityModel[];
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadTimeOfficeExtensionSuccess = createAction(
  '[Global] Load Timeofffice Extension Success',
  props<{
    data: TExtensionSetting[],
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
)
export const loadMoodbotDetailSuccess = createAction(
  '[Global] Load Moodbot Details Success',
  props<{
    data: IMoodSettingType[],
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
)
export const loadMoodbotReasionListSuccess = createAction(
  '[Global] Load Moodbot Reasion List Success',
  props<{
    data: IMoodReason[],
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
)

export const loadWorkflowInboxSettingSuccess = createAction(
  '[Global] Load Workflow Inbox Setting Success',
  props<{
    data: TWorkflowInboxSetting[],
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
)

export const loadHelpdeskTicketFeedbackSuccess = createAction(
  '[Global] Load Helpdesk Ticket Feedback Success',
  props<{
    data: THelpdeskTicketFeedback[],
    storename: string;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
)

export const showRefreshJobOpening = createAction(
  '[Global State] Show Refresh Job Opening', props<{ show: boolean }>()
);

export const loadJobOpeningSuccess = createAction(
  '[Recruitment] Load Job Opening Success',
  props<{ data: TReferralDataResponse[], storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const loadSocialWallWidgetSuccess = createAction(
  '[SocialWall] Load Widget Sequence Success',
  props<{
    data: {
      themeId: string,
      isEmployeeEditable: boolean,
      employeeWidgets: Array<IWidgetSequnceResponse>
    }, storename: string, versionId: string, employeeId: number, domainCode: string
  }>()
);

export const showRefreshRecruiterAccessSetting = createAction(
  '[Global State] Show Refresh Recruiter Access Setting', props<{ show: boolean }>()
);

export const loadRecruiterAccessSettingSuccess = createAction(
  '[Recruitment] Load Recruiter Access Setting Success',
  props<{ data: TRecruiterAccessSettingAPIResponse[], storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const refreshRecruitmentGeneralSetting = createAction(
  '[Global State] Show Refresh General Setting', props<{ show: boolean }>()
);

export const loadRecruitmentGeneralSettingSuccess = createAction(
  '[Recruitment] Load General Setting Success',
  props<{ data: TGeneralSettingAPIResponse[], storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const loadOneAIFeatureSuccess = createAction(
  '[Global] Load OneAI Feature Success',
  props<{ data: FeatureModel[], storename: string, versionId: string, employeeId: number, domainCode: string }>()
);

export const loadTaxRegimeSuccess = createAction(
  '[Global] Load Tax Regime Success',
  props<{
    data: TTaxRegimeResponse;
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);

export const loadPayrollGeneralSettingSuccess = createAction(
  '[Global] Load Payroll General Setting Success',
  props<{
    data: PayrollGeneralSettingModel;
    storename: EGlobalStateStoreNames;
    versionId: string;
    domainCode: string;
    employeeId: number;
  }>()
);



